import { icon } from './common'

const selectors = {
  'body.home section.header .number': 'pill',
  'section.header .media': 'step-2',
  '.vp-block-agency-contacts .email': 'mail',
  '.vp-block-agency-contacts .address': 'mail',
  '.vp-block-agency-contacts .tel': 'tel',
  '.form-simulation-calc .email': 'mail',
  '.form-simulation-calc .tel': 'tel',
}

for (const [selector, iconName] of Object.entries(selectors)) {
  const elements = document.querySelectorAll(selector)
  if (elements.length > 0) {
    for (const element of elements) {
      element.innerHTML = element.innerHTML + icon(iconName)
    }
  }
}
